module.exports = __webpack_public_path__ + "static/img/SP_H5.eff4493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SP_H5.png
// module id = gJXr
// module chunks = 34